<template>
  <div class="Background">

    <div style="display: flex; justify-content: space-between;">
      <h2 class="Title">
        인증서 관리
      </h2>

      <div class="link_location">
        설정관리 <v-icon small class="mdi mdi-chevron-right" />
        시스템관리 <v-icon small class="mdi mdi-chevron-right" />
        <a href="/cert/cert_list">인증서 관리</a>
      </div>

    </div>

    <v-row>
      <v-col class="text-right mb-2">
        <IconButton icon="mdi mdi-autorenew" small @click="refresh" class="mr-2" />
        <IconButton icon="mdi-trash-can-outline" small :disabled="selected.length === 0" @click="certificatesDelete"
          class="mr-2" />
        <!-- <router-link to="/cert/cert_import"></router-link> -->
          <TextButton buttonText="등록" isPrimary @click="openModal" />
      </v-col>
    </v-row>

    <!--table card-->
    <v-data-table :headers="headers" :items="certificates" :items-per-page="10"
      :footer-props="{ itemsPerPageOptions: [10, 20, 30, -1], itemsPerPageText: 'All' }" :loading="loading"
      loading-text="Loading data" :key="certificates.CertificateId" class="data-table" :disable-sort="true" show-select
      v-model="selected" item-key="CertificateId">

      <template v-slot:item.CertificateId="{ item }">
        <v-card small link outlined color="#eee" class="pa-2 pt-1 pb-1" @click="getInfo(item)"
          style="max-width: fit-content;">
          {{ item.CertificateId }}
        </v-card>
      </template>

      <template v-slot:item.Status="{ item }">
        <div v-if="item.Status === 1" style="color: #388E3C;">
          <v-icon class="mdi mdi-check-circle-outline mb-1 mr-1" small color="#388E3C">
          </v-icon><b>활성화</b>
        </div>
        <div v-else-if="item.Status === 0" style="color: #989898;">
          <v-icon class="mdi mdi-dots-horizontal-circle-outline mb-1 mr-1" small color="#989898">
          </v-icon><b>비활성화</b>
        </div>
      </template>

      <template v-slot:item.Deployable="{ item }">
        <div v-if="item.Deployable === true" style="color: #388E3C;">
          <v-icon class="mdi mdi-check-circle-outline mb-1 mr-1" small color="#388E3C">
          </v-icon><b>활성화</b>
        </div>
        <div v-else-if="item.Deployable === false" style="color: #989898;">
          <v-icon class="mdi mdi-dots-horizontal-circle-outline mb-1 mr-1" small color="#989898">
          </v-icon><b>비활성화</b>
        </div>
      </template>

    </v-data-table>

    <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />

    <AppDialogLarge :value="modalOpen" @input="modalOpen = $event">
      <template v-slot:title>
        인증서 세부 정보 입력
      </template>
      
      <template v-slot:content>
        <div class="suport_box">
          <strong>PEM 인코딩 인증서</strong> 본문, 개인 키 및 인증서연결을 아래에 붙여넣습니다.
        </div>

        <v-row>
        <v-col class="mb-4" cols="12">
          <h4 class="mb-2" style="color:black;">인증서 본문</h4>
          <textarea name="input-7-1" placeholder="PEM으로 인코딩된 인증서 본문을 붙여넣습니다." outlined
            v-model="cert" :rules="certRule" ref="certInput" class="textarea"></textarea>
          <v-snackbar v-model="snackbar" bottom right color="error" :timeout="3000">
            {{ snackbarText }}
          </v-snackbar>
        </v-col>
        <v-col class="mb-4" cols="12">
          <h4 class="mb-2" style="color:black;">인증서 개인 키</h4>
          <textarea name="input-7-1" placeholder="PEM으로 인코딩된 인증서 본문을 붙여넣습니다." outlined
            v-model="public_key" :rules="keyRule" ref="keyInput" class="textarea"></textarea>
        </v-col>
        <v-col cols="12">
          <h4 class="mb-2" style="color:black;">인증서 연결 - 선택 사항
          </h4>
          <textarea name="input-7-1" placeholder="PEM 암호화 인증서 연결을 붙여넣습니다." outlined
            v-model="chain" height="10" class="textarea"></textarea>
        </v-col>
      </v-row>

      </template>
      <template v-slot:actions>
          <TextButtonBlock buttonText="취소" @click="modalOpen = false" />
          <TextButtonBlock  buttonText="다음" @click="next" :loading="loadingDelete" isPrimary />
      </template>
    </AppDialogLarge>


  </div>
</template>

<script>
import IconButton from '@/components/ui/button/IconButton.vue';
import TextButton from '@/components/ui/button/TextButton2.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
import CertApi from "@/api/cert/CertApi";
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";
import AppDialogLarge from '@/components/app/AppDialogLarge.vue';


export default {
  components: {
    TextButton,
    IconButton,
    TextButtonBlock,
    AppSnackbar,
    AppDialogLarge
  },
  data() {
    return {
      headers: [
        { text: '인증서 아이디', value: 'CertificateId' },
        { text: '도메인 이름', value: 'Domain' },
        { text: '타입', value: 'CertificateType' },
        { text: '상태', value: 'Status' },
        { text: '사용중', value: 'Deployable' },
        { text: '만료 날짜', value: 'CertEndTime' },
        { text: '키 알고리즘', value: 'EncryptAlgorithm' },
      ],
      selected: [],
      loading: false,
      certificates: [],
      snackbar: false,
      snackbarText: '',
      snackbarError: false,
      snackbarErrorText: '',
      modalOpen: false,
    }
  },
  mounted() {
    this.certList();
  },
  methods: {
    certificatesDelete() {

    },
    refresh() {
      this.certList();
    },
    async certList() {
      try {
        this.loading = true;
        const response = await CertApi.listApi();
        this.loading = false;
        this.certificates = response.certificates;
      } catch (error) {
        console.error('error', error);
      }
    },
    openModal() {
      this.modalOpen = true;
    },
  }
}
</script>